import { ApPayeeDetailAllOfPaymentMethod } from 'ap-openapi';

type ForeignCurrencyDisableProps = {
  paymentMethod?: ApPayeeDetailAllOfPaymentMethod;
  currency?: string;
};

export const isForeignCurrencyDisable = ({
  paymentMethod,
  currency,
}: ForeignCurrencyDisableProps) => {
  const isBankTransfer = paymentMethod === 'bank_transfer';
  const isDisabled =
    !isBankTransfer &&
    currency !== undefined &&
    currency !== null &&
    currency !== 'JPY';
  return isDisabled;
};

export const getForeignCurrencyDisableProps = ({
  paymentMethod,
  currency,
}: ForeignCurrencyDisableProps) => {
  return {
    disabled: isForeignCurrencyDisable({
      paymentMethod,
      currency,
    }),
  };
};
